import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["className", "calendarAriaLabel", "previousMonthAriaLabel", "nextMonthAriaLabel"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { ChevronLeft, ChevronRight } from '@box/blueprint-web-assets/icons/Fill';
import { Gray65 } from '@box/blueprint-web-assets/tokens/tokens';
import { isSameDay, today, getLocalTimeZone } from '@internationalized/date';
import { clsx } from 'clsx';
import { forwardRef, useRef, useEffect } from 'react';
import { Calendar as Calendar$1, Button, Heading, CalendarGrid, CalendarGridHeader, CalendarHeaderCell, CalendarGridBody, CalendarCell } from 'react-aria-components';
import styles from './calendar.module.js'; // Dispatch duplicated event with bubbling enabled, so Radix popover knows that this click happened.

var handlePointerDownInCell = function handlePointerDownInCell(e) {
  var _e$currentTarget$pare;

  var newEvent = new PointerEvent('pointerdown', _objectSpread(_objectSpread({}, e), {}, {
    bubbles: true
  })); // Dispatch event on the parent to avoid infinite loop

  (_e$currentTarget$pare = e.currentTarget.parentElement) === null || _e$currentTarget$pare === void 0 ? void 0 : _e$currentTarget$pare.dispatchEvent(newEvent);
};
/**
 * Custom calendar cell that adds a pointerdown event listener to the CalendarCell.
 * This fixes DSYS-872 issue, where it takes 2 clicks to close the popover.
 */


var CustomCalendarCell = function CustomCalendarCell(_ref) {
  var date = _ref.date,
      className = _ref.className;
  var calendarCellRef = useRef(null);
  useEffect(function () {
    var calendarCell = calendarCellRef.current;
    var shouldModifyEventListener = calendarCell && !calendarCell.ariaDisabled;

    if (shouldModifyEventListener) {
      var _calendarCell$firstEl;

      // Attach the listener to the `div` with `role=button` instead of `td`, since we don't want the event to be triggered when clicking on td's padding.
      (_calendarCell$firstEl = calendarCell.firstElementChild) === null || _calendarCell$firstEl === void 0 ? void 0 : _calendarCell$firstEl.addEventListener('pointerdown', handlePointerDownInCell);
    }

    return function () {
      if (shouldModifyEventListener) {
        var _calendarCell$firstEl2;

        (_calendarCell$firstEl2 = calendarCell.firstElementChild) === null || _calendarCell$firstEl2 === void 0 ? void 0 : _calendarCell$firstEl2.removeEventListener('pointerdown', handlePointerDownInCell);
      }
    };
  }, []);
  return jsx(CalendarCell, {
    ref: calendarCellRef,
    className: className,
    date: date,
    children: function children(_ref2) {
      var formattedDate = _ref2.formattedDate;
      return jsx("span", {
        children: formattedDate
      });
    }
  });
}; // Ensure clicking on the header button triggers Radix onPointerDown event handler to close the popover with single click.


function continuePropagation(e) {
  e.continuePropagation();
}

var Calendar = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var className = props.className,
      calendarAriaLabel = props.calendarAriaLabel,
      previousMonthAriaLabel = props.previousMonthAriaLabel,
      nextMonthAriaLabel = props.nextMonthAriaLabel,
      rest = _objectWithoutProperties(props, _excluded);

  return jsxs(Calendar$1, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    "aria-label": calendarAriaLabel,
    className: clsx(styles.calendar, className),
    children: [jsxs("header", {
      className: styles.calendarHeader,
      children: [jsx(Button, {
        "aria-label": previousMonthAriaLabel,
        className: styles.calendarHeaderButton,
        onPressStart: continuePropagation,
        slot: "previous",
        children: jsx(ChevronLeft, {
          "aria-label": previousMonthAriaLabel,
          color: Gray65
        })
      }), jsx(Heading, {
        className: styles.calendarHeaderHeading
      }), jsx(Button, {
        "aria-label": nextMonthAriaLabel,
        className: styles.calendarHeaderButton,
        onPressStart: continuePropagation,
        slot: "next",
        children: jsx(ChevronRight, {
          "aria-label": nextMonthAriaLabel,
          color: Gray65
        })
      })]
    }), jsxs(CalendarGrid, {
      className: styles.calendarGrid,
      children: [jsx(CalendarGridHeader, {
        children: function children(day) {
          return jsx(CalendarHeaderCell, {
            className: styles.calendarHeaderCell,
            children: day
          });
        }
      }), jsx(CalendarGridBody, {
        children: function children(date) {
          return jsx(CustomCalendarCell, {
            className: clsx(styles.calendarCell, _defineProperty({}, styles.today, isSameDay(date, today(getLocalTimeZone())))),
            date: date
          });
        }
      })]
    })]
  }));
});
export { Calendar };